const KEY = 'klickbox-auth-token';

export const set = token => {
  window.sessionStorage.setItem(KEY, token);
};

export const get = () => window.sessionStorage.getItem(KEY);



/** WEBPACK FOOTER **
 ** ./src/helpers/auth/token.js
 **/